import React, { useEffect, useState } from 'react'
import { useContractStore } from 'context/ContractStore'
import { Button, Grid, TextField } from '@material-ui/core'
import { AsterToggleButton, AsterToggleButtonGroup } from 'asterX-UI/Buttons/toggle-button'
import { ContentCard } from 'components/ContentCard/ContentCard'
import { EmailIcon } from 'asterX-UI/Icons/EmailIcon'
import { PhonePlus } from 'asterX-UI/Icons/PhonePlus'
import { Geolocation } from 'asterX-UI/Icons/Geolocation'
import StandardTable from 'asterX-UI/Table/StandardTable'
import { CollectionService } from 'lib/api/services/collection.service'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import MaskedTextInput from 'asterX-UI/Inputs/MackedTextInput'
import { useSnackbar } from 'notistack'
import { useAuthStore } from 'context/AuthStore'
import { PluseIcon } from 'asterX-UI/Icons/PlusIcon'
import BottomDialog from 'asterX-UI/BottomDialog/BottomDialog'
import { useStyles } from './client.styles'
import {
  clientTypes,
  contractHistoryColumns,
  contractHistoryRows,
  getAdditionalContacts,
  getAddressData,
  getBasicData,
  getDocumentsData,
  getWorkplaceData
} from './const'
import { AddressModal } from './AddressModal/AddressModal'

export const Client = () => {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const { authStore, authStoreFunc } = useAuthStore()
  const {
    contractStore: { contractAll, contract },
    contractStoreFunc
  } = useContractStore()
  const [openModal, setOpenModal] = useState({
    addPhone: false,
    addEmail: false,
    addAddress: false
  })
  const [additionalPhone, setAdditionalPhone] = useState(null)
  const [additionalEmail, setAdditionalEmail] = useState(null)

  const [activeTab, setActiveTab] = useState('basicData')
  const [contractHistoryData, setContractHistoryData] = useState([])
  const [addressData, setAddressData] = useState([])
  const [contactsData, setContactsData] = useState([])

  const [openDialog, setOpenDialog] = useState(false)

  const tableData = {
    columns: contractHistoryColumns,
    rows: contractHistoryRows(contractHistoryData)
  }

  useEffect(() => {
    if (activeTab === 'contractHistory') {
      getContractHistory()
    }
    if (activeTab === 'address') {
      getAddresses()
    }
    if (activeTab === 'additionalContacts') {
      getContacts()
    }
  }, [activeTab])

  const getContractHistory = async () => {
    if (activeTab !== 'contractHistory' || !contractAll?.client?.personId) {
      return
    }

    const res = await CollectionService.getContractHistory(contractAll?.client?.personId)
    if (res?.data) {
      setContractHistoryData(res?.data?.list)
    }
  }

  const getAddresses = async () => {
    if (activeTab !== 'address' || !contract?.contractId) {
      return
    }
    const res = await CollectionService.getAddresses(contract?.contractId)
    if (res?.data) {
      setAddressData(res?.data)
    }
  }

  const getContacts = async () => {
    if (activeTab !== 'additionalContacts' || !contractAll?.client?.personId) {
      return
    }
    const res = await CollectionService.getContacts(contractAll?.client?.personId)
    if (res?.data) {
      setContactsData(res?.data?.list)
    }
  }

  const handleChangePhone = e => {
    const { value } = e.target
    setAdditionalPhone(value)
  }

  const handleChangeEmail = e => {
    const { value } = e.target
    setAdditionalEmail(value)
  }

  const handleClosePhoneEmail = () => {
    setOpenModal(prev => ({
      ...prev,
      addPhone: false,
      addEmail: false
    }))
    setAdditionalEmail(null)
    setAdditionalPhone(null)
  }

  const handleConfirmPhoneEmail = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const phoneRegex = /^\+7\s\(\d{3}\)-\d{3}-\d{2}-\d{2}$/

    if (openModal.addEmail && !emailRegex.test(additionalEmail)) {
      enqueueSnackbar('Заполните поле email корректно 😸', { variant: 'info' })
      return
    }

    if (openModal.addPhone && !phoneRegex.test(additionalPhone)) {
      enqueueSnackbar('Заполните поле номер телефона корректно 😸', { variant: 'info' })
      return
    }

    const data = {
      id: contractAll?.id,
      additionalEmail: additionalEmail || null,
      additionalPhone: additionalPhone || null
    }

    const res = await CollectionService.addEmailPhone(data)

    if (res?.data) {
      enqueueSnackbar('Успешно 😸', { variant: 'success' })
      handleClosePhoneEmail()
      contractStoreFunc.getById()
      contractStoreFunc.getPhoneNumbers()
    } else {
      enqueueSnackbar(`😿 Что-то пошло не так, статус ${res?.status}`, { variant: 'error' })
    }
  }

  return (
    <Grid container className={classes.wrapper}>
      <Grid item container className={classes.tableFilter}>
        <AsterToggleButtonGroup
          exclusive
          value={activeTab}
          onChange={(e, val) => {
            setActiveTab(val)
          }}
        >
          {clientTypes.map(({ label, code }, i) => (
            <AsterToggleButton key={`table-toggle-btn-${code}`} value={code}>
              {label}
            </AsterToggleButton>
          ))}
        </AsterToggleButtonGroup>
      </Grid>

      {authStore.isMobile && (
        <Button style={{ marginTop: 16 }} fullWidth variant="outlined" onClick={() => setOpenDialog(true)}>
          <PluseIcon />
          Добавить данные
        </Button>
      )}

      {authStoreFunc.isManager() && !authStore.isMobile && (
        <Grid
          item
          container
          xs={12}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          style={{ marginTop: 16 }}
          className={classes.actionButton}
        >
          <Grid item>
            <Button
              variant="outlined"
              onClick={() =>
                setOpenModal(prev => ({
                  ...prev,
                  addPhone: true
                }))
              }
            >
              <PhonePlus />
              Добавить телефон
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              onClick={() =>
                setOpenModal(prev => ({
                  ...prev,
                  addEmail: true
                }))
              }
            >
              <EmailIcon />
              Добавить e-mail
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              onClick={() =>
                setOpenModal(prev => ({
                  ...prev,
                  addAddress: true
                }))
              }
            >
              <Geolocation />
              Добавить адрес
            </Button>
          </Grid>
        </Grid>
      )}
      {activeTab === 'basicData' && (
        <Grid item container className={classes.contentCard}>
          <ContentCard data={getBasicData(contractAll)} line />
        </Grid>
      )}
      {activeTab === 'contractHistory' && (
        <Grid item container className={classes.contentCard}>
          <StandardTable
            tableData={tableData}
            btnStyle={{ backgroundColor: 'transparent', border: 'none', padding: 8, minWidth: 'auto' }}
          />
        </Grid>
      )}
      {activeTab === 'documents' && (
        <Grid item container className={classes.contentCard}>
          <ContentCard title="Паспорт" data={getDocumentsData(contractAll?.client)} columns="6" />
        </Grid>
      )}
      {activeTab === 'address' && (
        <>
          <Grid item container className={classes.contentCard}>
            <ContentCard title="Адрес прописки" data={getAddressData(addressData?.address)} />
          </Grid>
          <Grid item container className={classes.contentCard}>
            <ContentCard title="Адрес проживания" data={getAddressData(addressData?.registrationAddress)} />
          </Grid>
          <Grid item container className={classes.contentCard}>
            {(addressData?.additionals || []).map((item, index) => (
              <Grid item container className={classes.contentCard}>
                <ContentCard title={`Дополнительный адрес №${index + 1}`} data={getAddressData(item)} />
              </Grid>
            ))}
          </Grid>
        </>
      )}
      {activeTab === 'workplace' && (
        <>
          <Grid item container className={classes.contentCard}>
            <ContentCard data={getWorkplaceData(contractAll?.client)} line />
          </Grid>
        </>
      )}
      {activeTab === 'additionalContacts' && (
        <>
          <Grid item container className={classes.contactsCard}>
            {(contactsData || []).map((item, index) => (
              <ContentCard key={`key-${index}`} title={`Контакт №${index + 1}`} data={getAdditionalContacts(item)} />
            ))}
          </Grid>
        </>
      )}
      <ActionModal
        open={openModal.addPhone}
        onCancel={handleClosePhoneEmail}
        onClose={handleClosePhoneEmail}
        onConfirm={handleConfirmPhoneEmail}
        title="Добавить номер"
        labelConfirm="Добавить"
      >
        <Grid item xs={12}>
          <MaskedTextInput
            name="additionalPhone"
            value={additionalPhone || ''}
            onChange={handleChangePhone}
            fullWidth
            mask={'+7 (999)-999-99-99'}
            placeholder="Введите номер"
          />
        </Grid>
      </ActionModal>
      <ActionModal
        open={openModal.addEmail}
        onCancel={handleClosePhoneEmail}
        onClose={handleClosePhoneEmail}
        onConfirm={handleConfirmPhoneEmail}
        title="Добавить email"
        labelConfirm="Добавить"
      >
        <Grid item xs={12}>
          <TextField
            name="additionalEmail"
            value={additionalEmail || ''}
            onChange={handleChangeEmail}
            fullWidth
            placeholder="Введите email"
          />
        </Grid>
      </ActionModal>
      <AddressModal
        open={openModal.addAddress}
        onCancel={() =>
          setOpenModal(prev => ({
            ...prev,
            addAddress: false
          }))
        }
        onClose={() =>
          setOpenModal(prev => ({
            ...prev,
            addAddress: false
          }))
        }
        getAddresses={getAddresses}
      />
      <BottomDialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <Grid item container display="flex" alignItems="center" className={classes.actionButton}>
          <Button
            fullWidth
            variant="outlined"
            onClick={() =>
              setOpenModal(prev => ({
                ...prev,
                addPhone: true
              }))
            }
          >
            <PhonePlus />
            Добавить телефон
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={() =>
              setOpenModal(prev => ({
                ...prev,
                addEmail: true
              }))
            }
          >
            <EmailIcon />
            Добавить e-mail
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={() =>
              setOpenModal(prev => ({
                ...prev,
                addAddress: true
              }))
            }
          >
            <Geolocation />
            Добавить адрес
          </Button>
        </Grid>
      </BottomDialog>
    </Grid>
  )
}
